<template>
  <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6387 17.34L11.717 17.4287C12.0563 17.7679 12.5901 17.7941 12.9593 17.5069L13.048 17.4287L19.6362 10.8404L19.6752 10.7991L19.7271 10.7352L19.7946 10.6305L19.8449 10.5244L19.8782 10.4253L19.9054 10.2861L19.9119 10.1749L19.9092 10.1041L19.8929 9.986L19.8651 9.88113L19.8238 9.7766L19.7745 9.68484L19.7051 9.58626L19.6362 9.50941L13.048 2.92117C12.6804 2.55362 12.0845 2.55362 11.717 2.92117C11.3777 3.26045 11.3516 3.79431 11.6387 4.16353L11.717 4.25219L16.6968 9.23375H2.02955C1.50976 9.23375 1.08838 9.65512 1.08838 10.1749C1.08838 10.6947 1.50976 11.1161 2.02955 11.1161H16.6987L11.717 16.0976C11.3777 16.4369 11.3516 16.9708 11.6387 17.34Z"
      class="fill-current"
    />
  </svg>
</template>
